import { useCallback, useEffect, useState } from 'react';

const STORAGE_KEY = 'shenma_favorites';

const readFavorites = (): string[] => {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed.filter((item) => typeof item === 'string') : [];
  } catch {
    return [];
  }
};

const writeFavorites = (ids: string[]) => {
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(ids));
  } catch {
    // storage unavailable, ignore
  }
};

export function useFavorites() {
  const [favorites, setFavorites] = useState<string[]>([]);

  useEffect(() => {
    setFavorites(readFavorites());
  }, []);

  const isFavorite = useCallback(
    (id: string) => favorites.includes(id),
    [favorites],
  );

  const toggleFavorite = useCallback((id: string) => {
    let next: string[] = [];
    setFavorites((prev) => {
      next = prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id];
      writeFavorites(next);
      return next;
    });
    return next;
  }, []);

  return { favorites, isFavorite, toggleFavorite };
}